import axios from "axios";

export const AXIOS = axios;

// Create the custom Axios instance
const axiosInstance = axios.create({
    baseURL: "https://chatapi.nte.ai/v5",
    // baseURL: "https://chatstagingapi.nte.ai",

    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to attach the auth token
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken')
        console.log('tokentoken', token)

        // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZDEiOiI2ODEzMGEyNjdjMDY4NWY1ZTg3OGI4NTQiLCJpZDIiOiI2MTEzOGQ1YS1lMGUxLTcwODMtYmFkNC1jYWZmNjI1MTg1M2QiLCJpZDMiOiJhbm9vcG1vaGFuQHRhYnRyZWUuaW4iLCJpZDQiOiI2ODExZjEwMDQ4YjFiZGQ2MDcyMzE4ODUiLCJpYXQiOjE3NDcwNDcxMzh9.VO-ZQZlYWLQhzGqwHoljzbey9LbK2onjDHkDKJ6nlTE";

        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
